import { GICTransaction } from "./GICTransaction";
import _ from "lodash";
import Utils from "../libs/Utils";
import Holding from "./Holding";
import { Cols, TFrequency } from "../shared/Consts";
import PortUtils from "../portlibs/PortUtils";

export default class GICHolding extends Holding {
    override get payout(){ return this.yield/100 }
    override get yield(){return this.purchaseTransaction?.yield || 0}
    get frequency() : TFrequency {return "a"}
    get maturity() { return this.purchaseTransaction?.maturity || new Date(0) }
    get purchaseTransaction(){return this.gicTransactions.find(trans => trans.isBuy)||null}
    get account(){return this.portfolio.accountName(this.purchaseTransaction?.accountId||0) }

    get groupId(){
        const [type,market] = this.id.split("-")
        if (market=="CA") return type
        else return `${type}.${market}`
    }
    shouldFilter(search:string){ 
        return super.shouldFilter(search) || (!!this.purchaseTransaction?.note && this.purchaseTransaction.note.indexOf(search)>=0)
    }
    setPrice(){
        super.setPrice()
        this.price.setDate(this.maturity).setYield(this.yield).setEx(0).setPayout(this.price.yield/100).setFrequency(this.frequency)
        return this
    }
    value(col:string, toCad:boolean=false) : string{
        switch(col){
        case Cols.name:     return this.id
        case Cols.date:     return PortUtils.toDate(this.purchaseTransaction?.date)
        case Cols.maturity: return PortUtils.toDate(this.purchaseTransaction?.maturity)
        case Cols.note:     return this.purchaseTransaction?.note || ""
        case Cols.maturityMonth:    return this.purchaseTransaction ? (this.purchaseTransaction.maturity.getMonth()+1).toString() : ""
        default:            return super.value(col, toCad)
        }
    }
    compValue(col:string) : number|string {
        switch(col){
        case Cols.date:         return this.purchaseTransaction?.date.getTime() || 0
        case Cols.note:         return this.purchaseTransaction?.note || ""
        case Cols.maturity:     return this.purchaseTransaction?.maturity.getTime() || 0
        case Cols.maturityMonth:return this.purchaseTransaction?.maturity.getMonth() || 0
        default:                return super.compValue(col)
        }
    }
    override computePayout() {
        this.resetPayout()
        this.excessDiv = 0;

        const purchase = this.purchaseTransaction
        if (!purchase) return this

        const hist = this.dividendHistory
        const now = new Date()
        const current = now.getFullYear(), next = current+1
        const yld = this.yield
        let date = Utils.dateAdd(purchase.date, {year:1,date:1})
        let maturity = purchase.maturity
        let qty = purchase.quantity
        while(date<=maturity) {
            const year = date.getFullYear()
            const payout = qty*yld/100
            const receipt = hist.dividendOnMonth(date)
            if (year==current){
                this.a_payout += payout
                if (now>=date) this.ytd_payout = payout
            }
            else if (year==next){
                this.n_payout = payout
            }
            if (!PortUtils.isZero(payout)) this.distributions.push({id:`${this.id} (${this.account})`, date,amount:payout, holding:this, qty:qty, future:receipt==0})
            date = Utils.dateAdd(date, {year:1})
            qty += payout
        }
        return this;
    }
    get gicTransactions(){return this.transactions as GICTransaction[]}
}